import React from "react";

import { isPreviewing } from "@builder.io/sdk-react";

import { SecondaryNavigation as UISecondaryNavigation } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/SecondaryNavigation";
import { HeaderProvider } from "@jti/ui/eva-components/Header/context";

import { useDisplayModelComponent } from "@/libs/builder/hooks/useDisplayModelComponent";

type SecondaryNavigationProps = {
  children: React.ReactNode;
};

export function SecondaryNavigation({ children }: SecondaryNavigationProps) {
  const shouldDisplayModelComponent = useDisplayModelComponent(
    "secondary-navigation"
  );

  if (isPreviewing() && shouldDisplayModelComponent) {
    return (
      <HeaderProvider>
        <UISecondaryNavigation>{children}</UISecondaryNavigation>
      </HeaderProvider>
    );
  }
  return <UISecondaryNavigation>{children}</UISecondaryNavigation>;
}
